<template>
    <div class="info-body">
        <div class="section">
            <div class="section-header">
                <span>Satış Fırsatları</span>
                <div>
                    <button class="btn plus-icon" data-toggle="modal" data-target="#addDeal" @click="modalClear=false"><i class="fa fa-plus-circle" aria-hidden="true"></i></button>
                    <button class="btn" @click="detailCard('deals')">Tüm Fırsatlar</button>
                </div>
            </div>
            <div class="section-body">
                <div class="record" v-for="(deal, index) in dealList" :key="index" @click="detailCard('dealCard', deal._id.$oid)">
                    <div class="d-flex justify-content-between clr-grey">
                        <span>{{ deal.orgId.name }}</span>
                        <span>{{ formatDate(deal.expectedDate.$date, 'DD.MM.YYYY') }}</span>
                    </div>
                    <div class="d-flex justify-content-between">
                        <span>{{deal.title}}</span>
                        <span>{{ deal.value }} {{currencySymbol(deal.currency)}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="section">
            <div class="section-header">
                <span>İş Süreçleri</span>
                <div>
                    <button class="btn plus-icon" data-toggle="modal" data-target="#addProcessModal"><i class="fa fa-plus-circle" aria-hidden="true"></i></button>
                    <button class="btn" @click="detailCard('process')">Tüm Süreçler</button>
                </div>
            </div>
            <div class="section-body">
                <div class="record" v-for="(process, index) in processList" :key="index" @click="getProcessF(process._id.$oid)">
                    <div class="d-flex justify-content-between clr-grey">
                        <span>{{process.name}}</span>
                        <span>{{ formatDate(process.add_date.$date, 'DD.MM.YYYY') }}</span>
                    </div>
                    <div class="d-flex justify-content-between">
                        <span>{{ process.form.name }}</span>
                        <span>{{ userName }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="section">
            <div class="section-header">
                <span>Yaklaşan Aktiviteler</span>
                <div>
                    <button class="btn plus-icon" data-toggle="modal" data-target="#addActivity"><i class="fa fa-plus-circle" aria-hidden="true"></i></button>
                    <button class="btn" @click="detailCard('activities')">Tüm Aktiviteler</button>
                </div>
            </div>
            <div class="section-body">
                <div class="record" v-for="(activity, index) in activityList" :key="index" @click="editActivity(activity)">
                    <div class="d-flex justify-content-between clr-grey">
                        <span>{{activity.subject}}</span>
                        <span>{{ formatDate(activity.dueDate.$date, 'DD.MM.YYYY') }}</span>
                    </div>
                    <div class="d-flex justify-content-between">
                        <!-- <span>{{(users.find(u => u._id.$oid === activity.assignor.$oid).name) + " " + (users.find(u => u._id.$oid === activity.assignor.$oid).userName) | maxTextLength(14)}}</span> -->
                        <span>{{ getName(activity.assignedTo.$oid) }}</span>
                        <span class="type-info" :class="classObject(activity.type)">{{activityType(activity.type, $ml)}}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Add Deal Modal Begin -->
        <div class="modal fade" ref="dealModal" id="addDeal" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document" style="max-width:950px">
                <div class="modal-content crm-modal-content">
                    <newdeal :methods='type' :modalClear="modalClear" :user="this.user" :users="this.users" :customFieldArray="customFields"></newdeal>
                </div>
            </div>
        </div>
        <!-- Add Deal Modal End -->

        <!-- create process modal begin-->
        <div class="modal fade" id="addProcessModal" tabindex="-1" aria-labelledby="addProcessModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title createProcessModalHeader" id="addProcessModalLabel">{{$ml.get('CREATE_PROCESS')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body pt-3 pb-5">
                    <div class="row">
                        <div class="col-12">
                            <label class="new-label">{{$ml.get('PROCESS_NAME')}}</label>
                            <input type="text" v-model="processName" class="new-input">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <label class="new-label">{{$ml.get('FORMS')}}</label>
                            <select class="new-select bg-white" @change="changeForm($event)">
                                <option selected disabled>{{$ml.get('SELECT')}}</option>
                                <option v-for="(form,index) in listForms" :key="index" :selected="selectedForm===form._id">{{form.name}}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="modal-footer noteBtnStyle">
                    <button @click="closeButton()" type="button" class="btn-new" data-dismiss="modal">{{$ml.get('CANCEL')}}</button>
                    <button @click="addProcessF()" data-dismiss="modal" type="button" class="btn-new save ml-1">{{$ml.get('SAVE')}}</button>
                </div>
                </div>
            </div>
        </div>
        <!-- create process modal end-->

        <!-- Add Activity Modal Begin -->
        <div class="modal fade" id="addActivity" ref="vuemodal" tabindex="-1" role="dialog" data-backdrop="static" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document" style="max-width:750px!important">
                <div class="modal-content crm-modal-content">
                    <newActivity :methods="activityMethod" @refleshData="getActivitiesF()" :user="this.user" :clearModal="clearActivityModal" :listenStateStatus="this.listenStateStatus" :users="this.users" :customFieldArray="customFields"></newActivity>
                </div>
            </div>
        </div>
        <!-- Add Activity Modal End -->
    </div>
</template>

<script>
    import axios from 'axios'
    import { mapState } from 'vuex'
    import { mapActions, mapGetters } from 'vuex'
    import Newdeal from '../newDeal.vue'
    import NewActivity from '../newActivity.vue'

    export default {
        name: "InfoCard",
        components: {
            Newdeal,
            NewActivity
        },

        data () {
            return {
                dealList: [],
                processList: [],
                activityList: [],
                user: {},
                customFields: [],
                type: "save",
                activityMethod: "save",
                modalClear: false,
                listForms: [],
                processName: "",
                stepId: "",
                selectedForm: "",
                clearActivityModal: false,
                activityData: {}
            }
        },

        computed:{
            ...mapState([
                'baseUrl',
                'editLineStatu',
            ]),
            ...mapGetters(['userName', 'users']),
            listenStateStatus() { return this.$store.state.editLineStatu }
        },
        
        mounted() {
            this.callMetods()
            $(this.$refs.vuemodal).on("hidden.bs.modal", this.modalHidden)
        },

        methods: {
            ...mapActions([
                'updateOrgId',
                'updateDealId'
            ]),
            modalHidden(){
                if(this.editLineStatu){
                    this.getActivitiesF()
                }
                let statu=false
                this.$store.dispatch('editLineStatu', statu)
                this.clearActivityModal=true
                
            },
            callMetods() {
                this.getDealsF()
                this.getProcessesF()
                this.getActivitiesF()
                this.getAllFormsF()
            },
            classObject(type) {
                return {
                    typeCall: type === 1,
                    typeMeeting: type === 2,
                    typeTask: type === 3,
                    typeEmail: type === 4
                }
            },
            getDealsF(){
                var pagingOffset = 0;
                var pagingSize = 4;
                var sort = 'expectedDate'
                var sortType = -1

                var filter = {
                    "searchMode": "deals",
                    "name": "default",
                    "ands": [
                        {
                            "fieldName": "owner",
                            "operator": "equals",
                            "filterType": "deals",
                            "value": localStorage.cuid
                        }
                    ]
                }

                var params = {}
                params.pagingSize = pagingSize
                params.pagingOffset = pagingOffset
                params.filter = filter
                params.sort = sort
                params.sortType = sortType

                axios({
                    method:'POST',
                    url:'/getDealsForList',
                    baseURL: this.baseUrl,
                    data: params,
                    withCredentials:true
                }).then((res)=>{
                    return res
                }).then((res)=>{
                    
                    if(!res.data.status){
                      this.$router.push('/logout')
                     }
                    if(res.data.status.code==0){
                        this.dealList = res.data.content.deals
                        this.user = res.data.user
                        this.customFields = res.data.content.customFields
                    }
                    else if(res.data.status.code==2054) {
                        this.$router.push({ path: 'settings', query: { paymentStatus: 'userManagement' } })
                    }
                    else{
                        this.$notify({
                          group: 'foo',
                          type: 'error',
                          title: this.$ml.get('ERROR'),
                          text: res.data.status.desc
                        })
                    }
                })
            },
            getProcessesF(){
                axios({
                    method:'POST',
                    url:'/getProcesses',
                    baseURL: this.baseUrl,
                    withCredentials:true
                    }).then((res)=>{
                        return res
                    }).then((res)=>{
                    if(res.data.status){
                        if(res.data.status.code==0){
                            if(res.data.content.processes){
                               this.processList = res.data.content.processes[0].reverse().slice(0, 4) 
                            }
                        }
                    }else{
                        
                    }
                })
            },
            getActivitiesF() {
                var pagingOffset = 0;
                var pagingSize = 4;
                var sort = 'dueDate'
                var sortType = -1
                
                var filter = {
                    "searchMode": "activities",
                    "name": "default",
                    "ands": [
                        {
                            "fieldName": "assignedTo",
                            "operator": "equals",
                            "filterType": "activities",
                            "value": localStorage.cuid
                        }
                    ]
                }

                var params = {}
                params.pagingSize = pagingSize
                params.pagingOffset = pagingOffset
                params.filter = filter
                params.sort = sort
                params.sortType = sortType

                axios({
                    method:'POST',
                    url:'/getActivities',
                    baseURL: this.baseUrl,
                    data: params,
                    withCredentials:true
                }).then((res)=>{
                        return res
                }).then((res)=>{
                    if(!res.data.status){
                        this.$router.push('/logout')
                    }
                    if(res.data.status.code==0){
                        this.activityList = res.data.content.activities
                    }
                    else if(res.data.status.code==2054) {         
                        this.$router.push({ path: 'settings', query: { paymentStatus: 'userManagement' } })
                    } 
                    else{
                        if(res.data.status.details){
                            this.$notify({ 
                            group: 'foo',
                            type: 'error', 
                            title: this.$ml.get('ERROR'),
                            text: res.data.status.details
                            })
                        }else if(res.data.status.desc){
                            this.$notify({ 
                            group: 'foo',
                            type: 'error', 
                            title: this.$ml.get('ERROR'),
                            text: res.data.status.desc
                            })
                        }else{
                            this.$notify({ 
                            group: 'foo',
                            type: 'error', 
                            title: this.$ml.get('ERROR'),
                            text: this.$ml.get('UNKNOWN_ERROR')
                            })
                        }
                    }
                })
            },
            addProcessF(){
                if(this.checkParameters()){
                    let obj = {}

                    obj.form_id = this.selectedForm
                    obj.data = {}
                    obj.current_step = this.stepId
                    obj.name = this.processName
                    obj.customerFileIds = []

                    console.log(obj);

                    axios({
                        method:'POST',
                        url:'/addProcess',
                        baseURL: this.baseUrl,
                        data: obj,
                        withCredentials:true
                        }).then((res)=>{
                            return res
                        }).then((res)=>{
                        if(res.data.status){
                            if(res.data.status.code==0){
                                this.getProcessesF()
                                this.clearModal()
                            }else{
                                alert("hata")
                            }
                        }else{
                    
                        }
                    })
                }
                else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'warning', 
                        title: this.$ml.get('WARNING'),
                        text: "İş süreci adı ve form alanı boş geçilemez."
                    })
                    this.clearModal()
                }
            },
            getAllFormsF(){
                axios({
                    method:'POST',
                    url:'/getAllForms',
                    baseURL: this.baseUrl,
                    withCredentials:true
                    }).then((res)=>{
                        return res
                    }).then((res)=>{
                    if(res.data.status){
                        if(res.data.status.code==0){
                            this.listForms = res.data.content.forms[0].reverse()
                        }
                    }else{

                    }
                })
            },
            editActivity(activity) {
                this.clearActivityModal=true
                activity.edit = true
                this.activityData = activity
                $('#addActivity').modal('show')
                this.$store.dispatch('editLine', activity)
                let statu=true
                this.$store.dispatch('editLineStatu', statu)
            },
            detailCard(type, id) {
                if(type=='deals') {
                    this.$router.push('/deals')
                }
                else if(type=='process') {
                    this.$router.push('/process')
                }
                else if(type=='activities'){
                    this.$router.push('/activities')
                }
                else{
                    if(id!=="" || id!==null){
                        localStorage.dealId=id
                        this.updateDealId(id)
                        window.open('/'+type+'/'+id, '_blank');
                    }
                }
            },
            async getProcessF(id){
                await this.$router.push('/process')
                this.$root.$refs.formProcess.getProcessF(id)
            },
            changeForm(event){
                this.selectedForm = this.listForms[event.target.selectedIndex-1]._id.$oid
                this.stepId = this.listForms[event.target.selectedIndex-1].flow.sequence[0]
            },
            checkParameters(){
                var check = true

                if(this.processName == "" || this.stepId == "" || this.selectedForm == ""){
                    check = false
                }

                return check
            },
            closeButton(){
                $('#createProcessAlertModal').modal('show')
                this.clearModal()
            },
            clearModal(){
                this.selectedForm = ""
                this.processName = ""
                this.stepId = ""
            },
            getName(assignedTo){
                const user = this.users.find( ({ _id }) => _id.$oid === assignedTo );

                if(user.surName != undefined) return user.name + " " + user.surName

                return user.name
            },
            formatDate(value, format) {
                return this.$moment(value).format(format);
            },
            activityType:function (type,ml){
                const mlInst = ml || this.$ml;
                var activityType={ 1:mlInst.get('CALL'),2:mlInst.get('APPOINTMENT'),3:mlInst.get('TASK'),4:mlInst.get('E_MAIL')}
                return activityType[type] || ''
            },
            maxTextLength:function(value,max){
                if ( value && value.length > max ) {
                    return value.substring(0,max) + '...'
                } else {
                    return value || ''
                }
            }
        }
        
    }
</script>

<style>
    .info-body {
        padding: 21px 8px;
    }
    .section {
        margin-bottom: 32px;
    }
    .section-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 12px;
    }
    .section-header > span {
        font-size: 14px;
        font-weight: 600;
        color: #444444;
    }
    .section-header > div > button {
        font-size: 12px;
        font-weight: 500;
        color: #444444;
        padding: 5px 8px;
    }
    .section-header > div > button:hover {
        background: #bfbfbf;
    }
    .plus-icon {
        display: inline-flex;
        align-items: center;
        height: 30px;
        width: 30px;
        padding: 0 !important;
        justify-content: center;
    }
    .plus-icon > i {
        font-size: 18px;
        color: #444A6DB2;
        width: 16px;
        height: 16px;
    }
    .record {
        padding: 8px;
        border-bottom: 1px solid #E6E6E6;
    }
    .record:hover {
        background: #F2F2F2;
        cursor: pointer;
    }
    .clr-grey {
        color: #444A6DB2;
        font-size: 13px;
        font-weight: 400;
        line-height: 20px;
    }
    .type-info {
        padding: 2px 15px;
        border-radius: 8px;
    }
    .typeCall {
        background: rgba(108, 184, 160, 0.12);
        color: #6CB8A0;
    }
    .typeMeeting {
        background: rgba(143, 107, 238, 0.12);
        color: #8F6BEE;
    }
    .typeTask {
        background: rgba(98, 166, 241, 0.12);
        color: #62A6F1;
    }
    .typeEmail {
        background: rgba(228, 192, 0, 0.12);
        color: #787600;
    }
</style>
